<template>
    <div>
        <filter-container 
            :filterData="filterData"
            :filterDataSelected="filterDataSelected"
            :isPreloader="isPreloader"
            @onChangeFilter="onChangeFilter"
        />
        <div
            v-for="(tableKey, tableKeyIndex) in Object.keys(tableNames)"
            :key="tableKeyIndex"
            class="view-analytics-budget__table-container"
        >
            <div class="view-analytics-budget__table-title">
                {{tableNames[tableKey]}}
            </div>
            <table-base
                :columns="Object.keys(tables).length !== 0 ? tables[tableKey].columns : {}"
                :rows="Object.keys(tables).length !== 0 ? tables[tableKey].rows : []"
                :isPreloader="isPreloader"
                :isSort="true"
                :columnsSort="columnsSort[tableKey]"
                :isObjectCell="true"
            />
        </div>
    </div>
</template>

<script>
import FilterContainer from '../../components/Filter/FilterContainer';
import TableBase from '../../components/Tables/TableBase';
import mixinAnalytics from '../../mixins/mixinAnalytics';
import serviceApi from '../../services/serviceApi';
import schemeApi from '../../schemes/schemeApi';
let {routeAnalyticsBudget} = schemeApi;
export default {
    name:'ViewAnalyticsBudget',
    components: {
        FilterContainer,
        TableBase
    },
    mixins: [
        mixinAnalytics
    ],
    /**
     * Данные компонента
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {object} tableNames - названия таблиц
     * @property {string} tableNames.earn - название таблицы выручка
     * @property {string} tableNames.consumption - название таблицы себестоимость
     * @property {string} tableNames.profit - название таблицы прибыль
     * @property {string} tableNames.tax - название таблицы налог
     * @property {string} tableNames.profit_without_tax - название таблицы прибыль минус налог
     * @property {object} tables - таблицы
     */
    data: () => ({
        isPreloader: false,
        tableNames: {
            earn: "Выручка по месяцам",
            consumption: "Себестоимость по месяцам",
            profit: "Прибыль по месяцам",
            tax: "Налог по месяцам",
            profit_without_tax: "Прибыль с вычетом налога по месяцам"
        },
        tables: {}
    }),
    computed: {
        /**
         * тело запроса
         * @returns {object}
         */
        reqBody() {
            let reqBody = {
                filter_params: this.filterDataSelected
            }
            return reqBody;
        },
        /**
         * колонки по которым можно сортировать
         * @returns {object}
         */
        columnsSort() {
            let columnsSort = {};
            Object.keys(this.tables).forEach((name) => {
                Object.keys(this.tables[name].columns).forEach((column) => {
                    if (column === '1_month')
                        columnsSort[name] = {
                            ...columnsSort[name],
                            [column]: {typeColumn: 'Month'}
                        };
                    else
                        columnsSort[name] = {
                            ...columnsSort[name],
                            [column]: {typeColumn: 'Number'}
                        };
                });
            });
            return columnsSort;
        },
    },
    mounted() {
        this.getData();
    },
    methods: {
        /**
         * сделать запрос на получения данных
         * @async
         */
        async getData() {
            this.isPreloader = true;
            try {
                let {data = {}} = await serviceApi.post(routeAnalyticsBudget, this.reqBody);
                let {filter = {}, analytics = {}} = data;
                let {col_labels: colLabels = {}, months = {}, tables = {}} = analytics;
                
                this.setFilterData(filter);
                Object.keys(this.tableNames).forEach((tableKey) => {
                    this.tables = {
                        ...this.tables,
                        [tableKey]: this.collectTableData(tableKey, colLabels, months, tables[tableKey])
                    };
                });
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isPreloader = false;
        },
        /**
         * собрать данные таблиц
         * @param {string} tableKey - ключ таблицы
         * @param {object} colLabels - названия колонок
         * @param {object} months - месяца
         * @param {object} table - данные таблицы
         */
        collectTableData(tableKey, colLabels, months, table) {
            let columns = {
                '1_month': 'месяц',
                ...colLabels
            };
            let rows = [];
            for (let [monthsKey, monthsValue] of Object.entries(months)) {
                let row = {
                    '1_month': monthsValue,
                };
                Object.keys(colLabels).forEach((colKey) => {
                    row[colKey] = table[colKey][monthsKey];
                });
                rows.push(row);
            }   

            let tableDataCollected = {
                columns: columns,
                rows: rows
            };
            return tableDataCollected
        },
        /**
         * событие изменения фильтра
         * @param {object} newFilterData - новые данные фильтра
         */
        onChangeFilter(newFilterData) {
            this.setFilterSelected(newFilterData);
            this.filterDataSelected = newFilterData;
            this.getData();
        },
    }
}
</script>

<style lang="scss" scoped>
    .view-analytics-budget__table-container {
        margin-top: 20px;
    }
    .view-analytics-budget__table-title {
        font-size: 20px;
        margin-bottom: 20px;
    }
</style>